import {
  ChronoUnit,
  DateTimeFormatter,
  Duration,
  Instant,
  LocalDate,
  TemporalAccessor,
} from "@js-joda/core";
import { Locale } from "@js-joda/locale";

export const DISTANT_PAST = Instant.parse("0000-01-01T00:00:00Z");
export const DISTANT_FUTURE = Instant.parse("9999-12-31T23:59:59Z");
const MILLIS_PER_DAY = 24 * 60 * 60 * 1000;

export const localDateRange = ({
  startInclusive,
  endExclusive,
}: {
  startInclusive: LocalDate;
  endExclusive: LocalDate;
}): LocalDate[] => {
  const dates = [];
  for (
    let current = startInclusive;
    current.isBefore(endExclusive);
    current = current.plusDays(1)
  ) {
    dates.push(current);
  }
  return dates;
};

export const formatDate = (pattern: string, temporal: TemporalAccessor) =>
  DateTimeFormatter.ofPattern(pattern).withLocale(Locale.US).format(temporal);

export const daysBetween = (a: Instant, b: Instant) =>
  Duration.between(a, b).toMillis() / MILLIS_PER_DAY;

export const isSameYearMonth = (a: LocalDate, b: LocalDate) =>
  a.year() === b.year() && a.monthValue() === b.monthValue();

export const formatGestationalAge = (estimatedDateOfDelivery: LocalDate, asOf: LocalDate) => {
  const daysBeforeDueDate = asOf.until(estimatedDateOfDelivery, ChronoUnit.DAYS);
  const gestationDays = 40 * 7 - daysBeforeDueDate;
  const weeks = Math.floor(gestationDays / 7);
  const days = gestationDays % 7;
  return `${weeks}w+${days}d`;
};
